import React, { Fragment, useEffect } from 'react';
import { FormattedMessage } from 'react-intl/dist';
import useForm from '../common/form/hooks/useForm';

import GenericHeader from '../common/pageHeader/GenericHeader';
import ReCaptcha from '../common/form/recaptcha/ReCaptcha';
import Button from '../common/button/Button';
import Input from '../common/form/Input';

import { methods } from '../common/form/constants/validator';
import { configs } from '../../constants/configs/configs';
import { INPUT_TYPES } from '../common/form/constants/fieldTypes';
import { VALIDATION_TYPES } from '../../constants/inputs/validationTypes';
import accessCodeExpandedView from './fragments/accessCodeExpandedView';
import accessCodeNonExpandedView from './fragments/accessCodeNonExpandedView';


const AccessCodePage = (props) => {

    const { states } = configs;

    const {
        environment: {
            accessCodeExpandedViewEnabled,
            hideCaptcha,
            properties: {
                RECAPTCHA_SITE_KEY
            },
            stateCode,
            language
        }
    } = props;

    const reCaptchaWrapperExpandedViewEnabledClass = 'desktop:grid-col-8 tablet:grid-col-8 mobile:grid-col-8 grid-col-6 margin-tb-10';
    const reCaptchaWrapperNonExpandedViewEnabledClass = 'desktop:grid-col-8 tablet:grid-col-8 mobile:grid-col-8 grid-col-6 margin-b-20';
    const reCaptchaWrapperClass = accessCodeExpandedViewEnabled ? reCaptchaWrapperExpandedViewEnabledClass : reCaptchaWrapperNonExpandedViewEnabledClass;
    const { handleChange, values, errors, handleBlur, handleFocus, resetFields } = useForm(
        {},
        {
            accessCodeSelection: 'accessCode',
            accessCode: '',
            ssn:'',
            captchaValue:''
        },
        {
            accessCode: { type: 'maxLength', validator: (value)=> !methods.maxLength([value, VALIDATION_TYPES.ACCESSCODE_MAX_LENGTH]) },
            ssn: [
                { type: 'ssn', validator: (value)=> !methods.ssn(value) },
                { type: 'exactLength', validator: (value)=> !methods.exactLength([value, VALIDATION_TYPES.SSN_LENGTH]) },
            ]
        }
    );

    useEffect(()=>{
        resetFields(['accessCode']);
    },[values && values.accessCodeSelection]);


    const formDisabled =  (!values.ssn && !values.accessCode) || (!hideCaptcha && !values.captchaValue);

    const i18nReplacements = {
        accessCode: <FormattedMessage id="accounts.login_success.access_code"/>,
        ssn: <FormattedMessage id="accounts.login_success.access_code"/>
    };

    const handleSubmit = (e) => {
        if(formDisabled){
            e.preventDefault();
        } else {
            e.target.ssn.value = values.ssn.replace(/-/g, '');
        }
    };

    return (
        <Fragment>
            <GenericHeader
                text='accounts.login_success.header_1'
                tag='h1'
            />
            <div className="grid-container padding-0">
                <div className="grid-row padding-0">
                    <div className="gi-panel desktop:grid-col-fill tablet:grid-col-fill mobile-lg:grid-col-12 grid-col-12">
                        <div className="desktop:grid-col-10 tablet:grid-col-10 mobile-lg:grid-col-12 grid-col-12 section__content">
                            <form  action={ configs.endpoints.ACCOUNT_ACCESS_CODE } method='POST' onSubmit={handleSubmit}>
                                { !accessCodeExpandedViewEnabled && accessCodeNonExpandedView(values, i18nReplacements, handleChange, handleBlur, handleFocus, errors) }
                                { accessCodeExpandedViewEnabled && accessCodeExpandedView(values, i18nReplacements, handleChange, handleBlur, handleFocus, errors, stateCode) }
                                { !hideCaptcha &&
                                    <ReCaptcha
                                        //sitekey='6Le00O8UAAAAAPTFoCZLD6QUsUU2XWjucFSpWcv0'
                                        sitekey={ RECAPTCHA_SITE_KEY }
                                        key={language}
                                        lang={language}
                                        setCaptchaValue={values.captchaValue}
                                        onValidated={ ()=>handleChange({ target:{ name:'captchaValue', value:true } } ) }
                                        onChange={handleChange}
                                        outerClasses={['center']}
                                        wrapperClass={[reCaptchaWrapperClass]}
                                    />
                                }

                                <Input
                                    label={{
                                        text: 'common.no_text',
                                        isInputRequired:false,
                                        labelClasses: [''],
                                        wrapperClasses: ['']
                                    }}
                                    inputField={{
                                        name:'csrftoken',
                                        inputClasses: [''],
                                        type: 'hidden',
                                        value: window.csrf_token,
                                    }}
                                />
                                <Button
                                    { ...
                                        {
                                            id:'submit',
                                            name:'submit',
                                            type: 'submit',
                                            outerClass: ['margin-b-20'],
                                            classes:['gi-button__primary'],
                                            link_type: INPUT_TYPES.SUBMIT,
                                            btnText:'button.submit',
                                            disabled: formDisabled
                                        }
                                    }

                                />
                            </form>
                            { 
                                stateCode === states.IDAHO && 
                                    <FormattedMessage
                                        id="accounts.accessCode.id_help_text"
                                        values={{
                                            strong: function makeStrong(chunks){ return <strong>{ chunks }</strong>; },
                                        }}
                                    />
                            }
                        </div>
                    </div>
                    {/*<StartApplication />*/}
                </div>
            </div>
        </Fragment>
    );
};

export default AccessCodePage;